import { ABORT_ERROR_CODE, ABORT_ERROR_NAMES } from "@/constants/abortErrors";

// True for every "the request was intentionally cancelled" error shape: DOM AbortError (fetch/AbortController) and axios CanceledError/ERR_CANCELED. Cancelled requests (input cleared, navigation, tab closed) are expected outcomes, not errors — callers should skip toasts and exception capture.
export const isAbortError = (error: unknown): boolean => {
  if (typeof error !== "object" || error === null) {
    return false;
  }
  if (
    "name" in error &&
    typeof error.name === "string" &&
    ABORT_ERROR_NAMES.includes(error.name)
  ) {
    return true;
  }
  return "code" in error && error.code === ABORT_ERROR_CODE;
};
